import React, { Component } from 'react';

import '../../css/views/Projets.css';
import ZigZag from '../../components/ZigZag';
import Showcase from '../../components/Showcase';

import imageGradient2 from '../../images/gradient-2.jpg';
import imageElipsePoles from '../../images/elipse-poles.png';

import imageClient01 from '../../images/clients_01.jpg';
import imageClient02 from '../../images/clients_02.jpg';
import imageClient03 from '../../images/clients_03.jpg';
import imageClient04 from '../../images/clients_04.jpg';
import imageClient05 from '../../images/clients_05.jpg';
import imageClient06 from '../../images/clients_06.jpg';
import imageClient07 from '../../images/clients_07.jpg';
import imageClient08 from '../../images/clients_08.jpg';
import imageClient09 from '../../images/clients_09.jpg';
import imageClient10 from '../../images/clients_10.jpg';
import imageClient11 from '../../images/clients_11.jpg';
import imageClient12 from '../../images/clients_12.jpg';
import imageClient13 from '../../images/clients_13.jpg';
import imageClient14 from '../../images/clients_14.jpg';
import imageClient15 from '../../images/clients_15.jpg';
import imageClient16 from '../../images/clients_16.jpg';

class Projets extends Component {
  render() {
    return (
    <div className="projets inner-content-page">
        <section className="hero-unit">
            <div>
                <img src={imageGradient2} alt="" />
                <div>Une passion pour le digital, une expertise technique, un regard créatif pour un projet réussi.</div>
            </div>
            <div>
                <p>
                    Agence de conseil et de développement logiciel, ARCA Computing a su placer l'innovation au coeur de son approche.
                </p>
                <p>
                    <strong>Prise en charge numérique globale, accompagnement et suivi personnalisé, flexibilité</strong>, font d'ARCA Computing, une agence reconnue auprès de ses clients.
                </p>
            </div>
        </section>

        <section className="page-content">
            <Showcase large="false" />

            <section className="bloc-texte">
                <ZigZag />
                <h2>Nous les avons accompagnés dans leur transformation digitale</h2>
                <ZigZag />
            </section>
        </section>

            <section className="clients">
                <img src={imageGradient2} alt="" />
                <section className="page-content">
                <div className="upper-section">
                    <div className="lower-section">
                        <div className="figure">
                            <img src={imageElipsePoles} alt="" />
                            <img src={imageClient01} alt="" />
                        </div>
                        <div className="figure">
                            <img src={imageElipsePoles} alt="" />
                            <img src={imageClient02} alt="" />
                        </div>
                    </div>
                    <div className="lower-section">
                        <div className="figure">
                            <img src={imageElipsePoles} alt="" />
                            <img src={imageClient03} alt="" />
                        </div>
                        <div className="figure">
                            <img src={imageElipsePoles} alt="" />
                            <img src={imageClient04} alt="" />
                        </div>
                    </div>
                </div>
                <div className="upper-section">
                    <div className="lower-section">
                        <div className="figure">
                            <img src={imageElipsePoles} alt="" />
                            <img src={imageClient05} alt="" />
                        </div>
                        <div className="figure">
                            <img src={imageElipsePoles} alt="" />
                            <img src={imageClient06} alt="" />
                        </div>
                    </div>
                    <div className="lower-section">
                        <div className="figure">
                            <img src={imageElipsePoles} alt="" />
                            <img src={imageClient07} alt="" />
                        </div>
                        <div className="figure">
                            <img src={imageElipsePoles} alt="" />
                            <img src={imageClient08} alt="" />
                        </div>
                    </div>
                </div>
                <div className="upper-section">
                    <div className="lower-section">
                        <div className="figure">
                            <img src={imageElipsePoles} alt="" />
                            <img src={imageClient09} alt="" />
                        </div>
                        <div className="figure">
                            <img src={imageElipsePoles} alt="" />
                            <img src={imageClient10} alt="" />
                        </div>
                    </div>
                    <div className="lower-section">
                        <div className="figure">
                            <img src={imageElipsePoles} alt="" />
                            <img src={imageClient11} alt="" />
                        </div>
                        <div className="figure">
                            <img src={imageElipsePoles} alt="" />
                            <img src={imageClient12} alt="" />
                        </div>
                    </div>
                </div>
                <div className="upper-section">
                    <div className="lower-section">
                        <div className="figure">
                            <img src={imageElipsePoles} alt="" />
                            <img src={imageClient13} alt="" />
                        </div>
                        <div className="figure">
                            <img src={imageElipsePoles} alt="" />
                            <img src={imageClient14} alt="" />
                        </div>
                    </div>
                    <div className="lower-section">
                        <div className="figure">
                            <img src={imageElipsePoles} alt="" />
                            <img src={imageClient15} alt="" />
                        </div>
                        <div className="figure">
                            <img src={imageElipsePoles} alt="" />
                            <img src={imageClient16} alt="" />
                        </div>
                    </div>
                </div>
            </section>
        </section>
    </div>
    );
  }
}

export default Projets;



// WEBPACK FOOTER //
// ./src/views/projet/Projets.js